






import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/menu/Header.vue';
import CreateOnBoarding from '@/components/onboarding/CreateOnBoarding.vue';

@Component({
  components: {
    Header,
    CreateOnBoarding,
  },
})
export default class OnBoardingEdit extends Vue {}
